const NotificationIconWithBadge = ({ color = "#7B9E7E" }) => {
  return (
    <svg
      width="25"
      height="30"
      viewBox="0 0 25 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
        <g id="bell">
          <path
            id="Path"
            d="M24.8817 25.292L22.738 21.7186C21.7479 20.0693 21.2247 18.1802 21.2247 16.2574V13.1272C21.2247 9.17555 18.5877 5.83316 14.9819 4.75563V2.51448C14.9819 1.1373 13.8619 0.017334 12.4847 0.017334C11.1075 0.017334 9.98758 1.1373 9.98758 2.51448V4.75563C6.38177 5.83316 3.7448 9.17555 3.7448 13.1272V16.2574C3.7448 18.1802 3.22163 20.068 2.23277 21.7174L0.0890088 25.2908C-0.0271076 25.4843 -0.0296243 25.7241 0.0815174 25.9201C0.192659 26.1161 0.398672 26.2372 0.623413 26.2372H24.3461C24.5708 26.2372 24.7781 26.1161 24.8892 25.9214C25.0004 25.7265 24.9966 25.4843 24.8817 25.292Z"
            fill={color}
          />
          <path
            id="Path_2"
            d="M8.55273 27.4856C9.25692 28.9564 10.7477 29.9827 12.4844 29.9827C14.2211 29.9827 15.712 28.9564 16.4162 27.4856H8.55273V27.4856Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export default NotificationIconWithBadge;
